<template>
  <va-card :title="$t('menu.loads_by_data_integration') + ': ' + this.$route.params.dataIntegrationId">
    <div class="row">

      <div class="flex">
        <BackButton/>
      </div>

      <div class="flex xs12 md2 offset--md8">
        <va-select
          v-model="perPage"
          :value="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>
    </div>

    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      v-if="renderComponent"
      :fields="fields"
      :data="data"
      :per-page="parseInt(perPage)"
      :total-pages="parseInt(totalPages)"
      v-show="!loading"
      no-pagination
      api-mode
      @page-selected="readItems"
      :row-class="computedRowClass"
    >
    </va-data-table>

    <Pagination
      :currentPage="current_page"
      :totalPages="totalPages"
      :onChange="onPageChange"
      v-show="!loading"
    />
  </va-card>
</template>

<script>
import { mapState } from 'vuex'
import { Ability } from '@casl/ability'
import LoadAPI from '@/services/LoadAPI'
import * as spinners from 'epic-spinners'
import Pagination from '../shared/Pagination'
import BackButton from '../shared/BackButton'

export const ability = new Ability()

export default {
  name: 'modals',
  components: {
    ...spinners,
    Pagination,
    BackButton,
  },

  data () {
    return {
      showModalFinalize: false,
      integrationDate: '',
      page: 1,
      rowId: '',
      data: [],
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModal: false,
      ability: [],
      codeLoad: '',
      perPage: '10',
      totalPages: 0,
      perPageOptions: ['10', '20', '30', '50'],
      search: '',
      renderComponent: true,
      current_page: '',
      last_refresh: new Date(),
    }
  },

  beforeMount () {
    this.ability = ability.update(this.rules)
  },

  mounted () {
    this.readItems()
  },

  computed: {
    ...mapState(['rules', 'currentLocality', 'currentUser']),

    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.loads.id'),
      },
      {
        name: 'locality',
        title: this.$t('tables.loads.locality'),
      },
      {
        name: 'trip_number',
        title: this.$t('tables.loads.trip_number'),
      },
      {
        name: 'code',
        title: this.$t('tables.loads.code'),
      },
      {
        name: 'status',
        title: this.$t('tables.loads.status'),
      },
      {
        name: 'delivery_date',
        title: this.$t('tables.loads.delivery_date'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      return spinners.ScalingSquaresSpinner
    },
  },
  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems(this.currentPage)
    },

    '$store.state.currentLocality': function () {
      this.readItems(this.currentPage)
    },
  },
  methods: {
    onPageChange (page) {
      this.readItems(page)
    },

    async readItems (page = 1) {
      this.loading = true
      this.current_page = this.$route.params.current_page

      await LoadAPI.getLoadsByDataIntegration(this.$route.params.dataIntegrationId).then(response => {
        this.totalPages = response.data.total_pages
        this.current_page = response.data.current_page
        this.data = response.data.loads
        this.loading = false
      })
    },
  },
}
</script>
